class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);
document.addEventListener('submit', async function (e) {
  	const form = e.target.closest('#CartDrawer-DiscountForm');
    	if (!form) return;
      
      	e.preventDefault();
        
        	const input = document.getElementById('CartDrawer-DiscountInput');
          	const errorEl = document.getElementById('CartDrawer-DiscountError');
            	const applyBtn = document.getElementById('CartDrawer-DiscountApply');
              	const code = input.value.trim();
                	if (!code) return;
                  
                  	errorEl.hidden = true;
                    	applyBtn.disabled = true;
                      	applyBtn.textContent = 'Applying...';
                        
                        	try {
                          		const cartDrawer = document.querySelector('cart-drawer');
                              		const sections = cartDrawer.getSectionsToRender().map((s) => s.id ?? s.section);
                                  
                                  		const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
                                      			method: 'POST',
                                            			headers: { 'Content-Type': 'application/json' },
                                                  			body: JSON.stringify({
                                                        				discount: code,
                                                                				sections: sections,
                                                                        				sections_url: window.location.pathname
                                                                                			})
                                                                                      		});
                                                                                          
                                                                                          		if (!response.ok) throw new Error('Request failed');
                                                                                              
                                                                                              		const state = await response.json();
                                                                                                  
                                                                                                  		cartDrawer.renderContents(state);
                                                                                                      
                                                                                                      		applyBtn.disabled = false;
                                                                                                          		applyBtn.textContent = 'Apply';
                                                                                                              		input.value = '';
                                                                                                                  
                                                                                                                  	} catch (err) {
                                                                                                                    		errorEl.textContent = "That code isn't valid or has expired.";
                                                                                                                        		errorEl.hidden = false;
                                                                                                                            		applyBtn.disabled = false;
                                                                                                                                		applyBtn.textContent = 'Apply';
                                                                                                                                    	}
                                                                                                                                      });
                                                                                                                                      class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('click', function (event) {
  	const toggleBtn = event.target.closest('#CartDrawer-DiscountToggle');
    	if (!toggleBtn) return;

      	const wrapper = document.getElementById('CartDrawer-DiscountFormWrapper');
        	if (!wrapper) return;

          	const isOpen = !wrapper.hasAttribute('hidden');
            	if (isOpen) {
              		wrapper.setAttribute('hidden', '');
                  		toggleBtn.classList.remove('is-open');
                      	} else {
                        		wrapper.removeAttribute('hidden');
                            		toggleBtn.classList.add('is-open');
                                		const input = document.getElementById('CartDrawer-DiscountInput');
                                    		if (input) input.focus();
                                        	}
                                          });